export const CHECKBOX_SIZES = {
  S: 's',
  SM: 'sm',
  MD: 'md',
  CUSTOM: 'custom'
}
